import { useDispatch, useSelector } from 'react-redux';

import { navbarSelectors } from '../../../selectors';
import { navbarActions } from '../../../slice';

import BrandIcon from 'assets/landing/Brand.svg';

import { Modal } from '@/components/modal';
import { HamberMenuModalContent } from './content';
import Icon from '@/components/icon';

export const HamberMenuModal = () => {
  const dispatch = useDispatch();
  const { isOpen } = useSelector(navbarSelectors.hamberMenuModal);
  const handleModalClose = () => {
    dispatch(navbarActions.toggleHamberMenuModal(false));
  };

  const titleOfModal = <Icon src={BrandIcon} />;

  return (
    <Modal
      title={titleOfModal}
      isOpen={isOpen}
      onClose={handleModalClose}
      anchor="top"
    >
      <HamberMenuModalContent />
    </Modal>
  );
};
